import type { AbsolutePath } from "shelving";
import { Icon, MenuButton, PathButton } from "shared/react";
import { getProfilePath } from "shared/schema";
import { useItem } from "../util/db.js";
import { ProfileMenu } from "./ProfileMenu.js";

export function ProfileNavigation({ uid }: { uid: string }): React.ReactElement {
	const profile = useItem("profile", uid).data;
	const path: AbsolutePath = getProfilePath(profile);
	return (
		<nav className="space-none pad-none flex-row flex-stretch width-wide">
			<PathButton path={`${path}`} title="Posts">
				<Icon icon="post" />
			</PathButton>
			<PathButton path={`${path}/earned/badges`} title="Earned badges">
				<Icon icon="badge" />
			</PathButton>
			<MenuButton menu={<ProfileMenu uid={uid} />} />
		</nav>
	);
}
